import { Grid } from '@lifechurch/react-ion';
import styled from 'styled-components';

export const NonClickableTableRow = styled(Grid)`
  margin-inline-start: -8px;
  padding: 5px;
  padding-inline-end: 0;
  padding-inline-start: 8px;
  align-items: center;
  grid-template-columns: 60px 1fr 120px 100px 80px 20px;
  grid-column-gap: 1rem;
  position: relative;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p:not(:first-of-type) {
    color: ${props => props.theme.colors.gray80};
  }
`;
